import request from '../utils/request'

export default {

  // 活动详情
  promotionDetail: (data: any) => {
    return request({
      url: '/app/promotion/promotionDetail',
      method: 'post',
      data
    })
  },

  // 活动列表
  allList: (data: any) => {
    return request({
      url: '/app/promotion/allList',
      method: 'post',
      data
    })
  },
  // 区投放活动列表
  communityIdList: (data: any) => {
    return request({
      url: '/app/promotion/getForCommunity',
      method: 'get',
      params:data
    })
  },
  // 城市投放活动列表
  cityList: (data: any) => {
    return request({
      url: '/app/promotion/getForCity',
      method: 'get',
      params:data
    })
  },


  // 我参与的
  myList: (data: any) => {
    return request({
      url: '/app/promotion/myList',
      method: 'post',
      data
    })
  },

  // 取消报名
  cancelEnroll: (data: any) => {
    return request({
      url: '/app/promotion/cancelEnroll',
      method: 'post',
      data
    })
  },


}
